import OrganizationAPI from '../../../api/organizations'

const RankingStatisticsMixin = {
  computed: {
    statistics () {
      return this.rankingData.statistics
    },
    accountStatistics () {
      return this.statistics.account
    },
    mailchimpStatistics () {
      return this.statistics.mailchimp
    },
    activityStatistics () {
      return this.statistics.activities
    },
    externalMedia () {
      return this.statistics.external_media
    },
    eventStatistics () {
      return this.statistics.event
    },
    jobBoardStatistics () {
      return this.statistics.job_board
    }
  },
  data: function () {
    return {
      rankingData: null,
      accountIDToHighlight: null,
      isLoading: false,
      filter: {
        member_type: 'all_members',
        date: 'july_2020',
        compare_date: '90_days'
      },
      dateFields: [
        {
          text: 'Last 30 Days',
          value: '30_days'
        },
        {
          text: 'Last 90 Days',
          value: '90_days'
        },
        {
          text: 'Year to Date',
          value: 'year_to_date'
        },
        {
          text: 'Since July 2020',
          value: 'july_2020'
        },
        {
          text: 'One Year Ago',
          value: 'last_year'
        }
      ],
      memberType: [
        {
          text: 'All Members',
          value: 'all_members'
        },
        {
          text: 'F&S Members',
          value: 'fs_members'
        },
        {
          text: 'Top 70 & High Potential Members',
          value: 't70_members'
        },
        {
          text: 'Top 70 Members w/o F&S',
          value: 't70_members_wo_fs'
        },
        {
          text: 'Prospective Members',
          value: 'prospective_members'
        }
      ]
    }
  },
  methods: {
    setOrganizationData () {
      this.accountIDToHighlight = null
      this.isLoading = true
      this.$store.commit('setIsLoading', true)
      OrganizationAPI.getOrganizationRankings(this.filter).then(
        response => {
          this.isLoading = false
          this.rankingData = response.data
          this.$store.commit('setIsLoading', false)
        }
      )
    },
    labelRank (title, description, data) {
      data.title = title
      data.description = description
      return data
    },
    getStatistics () {
      return [
        this.getAccountData(),
        this.getEventData(),
        this.getMailChimpData(),
        this.getActivitiesData(),
        this.getExternalMediaObjects(),
        this.getViewingData()
      ]
    },
    //  ACCOUNTS
    getAccountData () {
      return {
        title: 'General Account Data',
        description: '',
        statistics: [
          [
            this.labelRank(
              'Accounts Created',
              'New accounts created in the Neon CRM. While efforts are made to deduplicate these records, there will be occasional duplicates.',
              this.accountStatistics.accounts_created
            ),
            this.labelRank(
              'Job Board Usage',
              'Count of approved job postings by a company.',
              this.jobBoardStatistics.job_listings
            )
          ]
        ]
      }
    },
    getEventData () {
      return {
        title: 'Event Data',
        description: '',
        statistics: [
          [
            this.labelRank(
              'Event Attendance',
              'Number of folks in attendance at events.',
              this.eventStatistics.attendance
            ),
            this.labelRank(
              'Distinct Events Attended',
              'Unique events attended. NOTE: count in main box represents how many unique events each member attended. Rankings have expected number.',
              this.eventStatistics.events_attended
            )
          ]
        ]
      }
    },
    //  MAILCHIMP
    getMailChimpData () {
      return {
        title: 'MailChimp Data',
        description: '',
        statistics: [
          this.getMailChimpSubscriptionData(),
          [
            this.labelRank(
              'Opens',
              'Opens of MAA emails sent via MailChimp.',
              this.mailchimpStatistics.open
            ),
            this.labelRank(
              'Clicks',
              'Clicks on links in MAA emails sent via MailChimp.',
              this.mailchimpStatistics.click
            )
          ],
          this.getMailChimpSubscriptionSources()
        ]
      }
    },
    getMailChimpSubscriptionData () {
      return [
        this.labelRank(
          'Subscribes',
          'Subscribes to the MAA mailing list.',
          this.mailchimpStatistics.subscribed
        ),
        this.labelRank(
          'Unsubscribes',
          'Unsubscribes of the MAA mailing list.',
          this.mailchimpStatistics.unsubscribed
        ),
        this.labelRank(
          'Cleans',
          'Emails cleaned, or deemed invalid, by MailChimp.',
          this.mailchimpStatistics.cleaned
        ),
        this.labelRank(
          'All subscribers (date agnostic)',
          'All subscribers to our mailing list, regardless of their subscription date.',
          this.mailchimpStatistics.total_subscribers
        )
      ]
    },
    getMailChimpSubscriptionSources () {
      return [
        this.labelRank(
          'API Additions',
          'Added by the MAA server.',
          this.mailchimpStatistics['API - Generic']
        ),
        this.labelRank(
          'Embeded Form',
          '',
          this.mailchimpStatistics['Embed Form']
        ),
        this.labelRank(
          'Hosted Form',
          '',
          this.mailchimpStatistics['Hosted Signup Form']
        )
      ]
    },
    // ACTIVITIES
    getActivitiesData () {
      return {
        title: 'Activity Data',
        description: '',
        statistics: [
          [
            this.labelRank(
              'Meetings',
              '',
              this.activityStatistics['Meeting']
            ),
            this.labelRank(
              'Referrals',
              '',
              this.activityStatistics['Referrals']
            ),
            this.labelRank(
              'External Emails',
              '',
              this.activityStatistics['external_emails_sent']
            )
          ],
          [
            this.labelRank(
              'Advocacy',
              '',
              this.activityStatistics['Advocacy']
            ),
            this.labelRank(
              'Content',
              '',
              this.activityStatistics['Content']
            ),
            this.labelRank(
              'Renewals',
              '',
              this.activityStatistics['Renewals']
            ),
            this.labelRank(
              'Invites',
              '',
              this.activityStatistics['Invite']
            )
          ]
        ]
      }
    },
    //  External Media Objects
    getExternalMediaObjects () {
      return {
        title: 'External Media Data',
        description: '',
        statistics: [
          [
            this.labelRank(
              'MailChimp Emails',
              '',
              this.externalMedia.mailchimp_mentions
            ),
            this.labelRank(
              'Posts on MAA.org',
              '',
              this.externalMedia.wordpress_mentions
            ),
            this.labelRank(
              'Podcast Appearances',
              '',
              this.externalMedia.podcast
            )
          ],
          [
            this.labelRank(
              'Webinar Appearaces',
              '',
              this.externalMedia.webinar
            ),
            this.labelRank(
              'Tweets',
              '',
              this.externalMedia.tweet
            ),
            this.labelRank(
              'LinkedIn Posts',
              '',
              this.externalMedia.linkedin_mentions
            )
          ]
        ]
      }
    },
    //  VIEWINGS
    getViewingData () {
      return {
        title: 'External Media Consumption',
        description: '',
        statistics: [
          [
            this.labelRank(
              'LinkedIn Impressions',
              '',
              this.externalMedia.linkedin_impressions
            ),
            this.labelRank(
              'WordPress Views',
              '',
              this.externalMedia.wordpress_views
            ), this.labelRank(
              'MailChimp Opens',
              'Number of opens of emails that mentioned a member.',
              this.externalMedia.mailchimp_opens
            )
          ]
        ]
      }
    }
  }
}

export default RankingStatisticsMixin



// WEBPACK FOOTER //
// ./src/components/organizations/rankings/RankingStatisticsMixin.js